import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {map, finalize, takeWhile} from 'rxjs/operators';
import {AIStoryGenerationStatus} from 'src/app/shared/models/generation-status.interface';
import {TranslateModule} from '@ngx-translate/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {NgIf, NgClass, AsyncPipe} from '@angular/common';

@Component({
  selector: 'app-generation-progress-button',
  templateUrl: 'generation-progress-button.component.html',
  styleUrls: ['generation-progress-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    AsyncPipe,
    TranslateModule
  ]
})
export class GenerationProgressButtonComponent {
  @Input() set generationStatus(status: AIStoryGenerationStatus) {
    if (status) {
      this.generationStatus$.next(status);
    }
  }
  private expanded$ = new BehaviorSubject<boolean>(true);
  private generationStatus$ = new BehaviorSubject<AIStoryGenerationStatus>({
    total: 0,
    completed: 0,
    failed: 0
  });
  private generationFinished$ = this.generationStatus$.pipe(
    map(({total, completed, failed}) => total === completed + failed),
    takeWhile(generated => !generated, true),
    finalize(() => this.expanded$.next(true))
  );
  public vm$ = combineLatest([
    this.expanded$,
    this.generationStatus$,
    this.generationFinished$
  ]).pipe(
    map(([expanded, generationStatus, generationFinished]) => ({
      expanded,
      generationStatus,
      generationFinished
    }))
  );

  public toggle(): void {
    this.expanded$.next(!this.expanded);
  }

  private get expanded(): boolean {
    return this.expanded$.value;
  }
}
